// PersianDatePicker.jsx
import React, { useEffect, useState } from "react";
import DatePicker from "react-datepicker2";
import moment from "moment-jalaali";
import { Row, Col, Button, Space } from "antd";
import { DeleteOutlined } from "@ant-design/icons";

// بارگذاری تنظیمات فارسی moment-jalaali
moment.loadPersian({
  usePersianDigits: true,
  dialect: "persian-modern"
});

const PersianDatePicker = ({
  setPersianDate,
  disable = false,
  setDefault = true,
  onClose,
  label,
  placeholder="انتخاب تاریخ"
}) => {
  const [value, setValue] = useState(null);

  // در بارگذاری اول مقدار پیش‌فرض (امروز) تنظیم شود
  useEffect(() => {
    if (setDefault) {
      const now = moment();
      handleDateChange(now);
    }

  }, []);

  const handleDateChange = date => {
    setValue(date);
    if (date) {
      setPersianDate({
        gregorian: date.clone().locale("en").format("YYYY-MM-DD"),
        persian: date.format("jYYYY/jMM/jDD"),
        julianDay: date.valueOf()
      });
    } else {
      setPersianDate({
        gregorian: null,
        persian: null,
        julianDay: null
      });
    }
  };

  const clearDate = () => {
    setValue(null);
    setPersianDate({
      gregorian: null,
      persian: null,
      julianDay: null
    });
    if (onClose) onClose();
  };

  return (
    <Row align="middle" gutter={8}>
      {label && <Col>{label}</Col>}
      <Col>
        <Space>
          <DatePicker
            isGregorian={false}                    // تقویم شمسی
            timePicker={false}                     // فقط تاریخ
            value={value}
            onChange={handleDateChange}
            disabled={disable}
            onBlur={onClose}
            inputFormat="jYYYY/jMM/jDD"            // فرمت شمسی
            placeholder={placeholder}
          />
          <Button
            icon={<DeleteOutlined />}
            onClick={clearDate}
            disabled={disable}
          />
        </Space>
      </Col>
    </Row>
  );
};

export default PersianDatePicker;
